<script lang="ts">
	const lineWidths = [100, 100, 100, 100, 100, 35] as const;
</script>

<div class="skeleton-container">
	{#each lineWidths as width}
		<div class="skeleton-line" style="inline-size: {width}%;" />
	{/each}
</div>

<style>
	.skeleton-container {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		block-size: 100%;
		inline-size: 80%;
		padding-block-start: 2rem;
	}

	.skeleton-line {
		min-block-size: 28px;
		animation: pulse 1.5s infinite ease-in-out;
		border-radius: 4px;
		background: #e0e0e0;
	}

	@keyframes pulse {
		0% {
			opacity: 1;
		}

		50% {
			opacity: 0.5;
		}

		100% {
			opacity: 1;
		}
	}
</style>
